import {
  groupByDesign,
  useConvertProject,
  usePricing,
  useProject,
} from '@customink/project-service-react-components';

import {
  useCheckoutPending,
  useDistributedShipStrategy,
} from '@/hooks/Project';
import { havePositiveQuantity } from '@/utils/checkout';

export const useCheckoutEnabled = () => {
  const { data: project } = useProject();
  const [, { isError: isCheckoutError }] = useConvertProject();
  const isCheckoutPending = useCheckoutPending();

  const { isLoading: isLoadingPricing, isInvalid: isPricingInvalid } =
    usePricing();

  const groupedItems = groupByDesign(project?.items || []);
  const hasValidQuantities = Object.values(groupedItems).every((items) =>
    havePositiveQuantity(items),
  );

  const [{ isSelfService, shippingType }] = useDistributedShipStrategy();

  const isSelfServiceInvalid =
    project?.configuration?.shippingType === shippingType && !isSelfService;

  return (
    !isCheckoutError &&
    !isCheckoutPending &&
    !isLoadingPricing &&
    !isPricingInvalid &&
    !isSelfServiceInvalid &&
    hasValidQuantities
  );
};
